var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.4987C14.6663 4.8168 11.6815 1.83203 7.99967 1.83203C4.31777 1.83203 1.33301 4.8168 1.33301 8.4987C1.33301 12.1806 4.31777 15.1654 7.99967 15.1654C11.6815 15.1654 14.6663 12.1806 14.6663 8.4987Z",
    fill: "white",
    stroke: "#545D69",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16105 11.832V8.4987C8.16105 8.18443 8.16105 8.0273 8.06339 7.92963C7.96579 7.83203 7.80865 7.83203 7.49438 7.83203",
    stroke: "#545D69",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99438 5.83203H8.00039",
    stroke: "#545D69",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.d97fdcc408cb9801ff5c04cbe9e2b093.svg";
export { ForwardRef as ReactComponent };